import React from 'react';
import { useTranslation } from 'react-i18next';
import { Operation } from '../../Transactions.types';
import * as S from './OperationDetailsContent.styles';
import {
  getOperationRows,
  getOperationTitle,
} from './OperationDetailsContent.helpers';
import { SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { formatNumber } from '@/utils/helpers';

interface OperationDetailsContentProps {
  operation: Operation;
  onClose: () => void;
}

export function OperationDetailsContent({
  operation,
  onClose,
}: OperationDetailsContentProps) {
  const { t } = useTranslation();

  const title = getOperationTitle(operation, t);
  const rows = getOperationRows(operation, t);
  const totalIndex = rows.findIndex(row => row.isTotal);

  return (
    <S.Container>
      <S.Header>
        <S.Title>{title}</S.Title>
        <S.CloseButton role="button" aria-label="Close" onClick={onClose} />
      </S.Header>

      {operation.ad ? (
        <S.AdCard href={operation.ad.path} onClick={onClose}>
          <S.AdImage
            src={operation.ad.image || '/images/profile-square.svg'}
            alt={operation.ad.title}
          />
          <S.AdInfo>
            <S.AdPrice>
              {operation.ad.price
                ? `${formatNumber(operation.ad.price, 0)} AZN`
                : ''}
            </S.AdPrice>
            <S.AdTitle>{operation.ad.title}</S.AdTitle>
          </S.AdInfo>
          <S.AdChevron>
            <SmallChevronIcon width={6} height={12} />
          </S.AdChevron>
        </S.AdCard>
      ) : null}

      <S.Details>
        {rows.map((row, index) => {
          const { isTotal } = row;
          const LabelComponent = isTotal ? S.TotalLabel : S.Label;
          const ValueComponent = isTotal ? S.TotalValue : S.Value;

          return (
            <React.Fragment key={row.label}>
              {index === totalIndex && index > 0 ? <S.Divider /> : null}
              <S.Row>
                <LabelComponent>{row.label}</LabelComponent>
                <ValueComponent>{row.value}</ValueComponent>
              </S.Row>
            </React.Fragment>
          );
        })}
      </S.Details>
    </S.Container>
  );
}
